import { Modal, Button } from "react-bootstrap";

export default function CredentialsModal({ show, handleClose, credentials }) {
  if (!credentials) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="onboarding-modal"
      style={{ zIndex: 2000 }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Employee Credentials</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Employee ID:</strong> {credentials.employee_id}
        </p>
        <p>
          <strong>Password:</strong> {credentials.password}
        </p>
        <p>
          <strong>Role:</strong> {credentials.role_name}
        </p>
        <p>
          <strong>Attendance Type:</strong> {credentials.attendance_type}
        </p>
        <p>Share these credentials securely with the employee.</p>
        <p style={{ color: "green", fontWeight: "500" }}>
          ✅ Credentials sent to the employee's registered email address.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
